module.exports = __webpack_public_path__ + "static/2021-03e035f261119f615e9c37af0ad049cc.jpeg";